import React, { useState } from "react";
import Spinner from "../utils/Spinner";
import * as XLSX from "xlsx";

import { RiFileExcel2Fill } from "react-icons/ri";

const ordenarPartidos = (partidos) => {
  return partidos.sort((a, b) => {
    const diasSemana = [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];

    // Obtener el índice del día de la semana para ambos partidos
    const diaA = diasSemana.indexOf(a.dia);
    const diaB = diasSemana.indexOf(b.dia);

    // Si los días de la semana son diferentes, ordenar por día
    if (diaA !== diaB) {
      return diaA - diaB;
    } else {
      // Si los días son iguales, ordenar por hora
      const horaA = parseInt(a.idTurno.horario);
      const horaB = parseInt(b.idTurno.horario);
      if (horaA !== horaB) {
        return horaA - horaB;
      }
    }
  });
};

const obtenerTodasLasCanchas = (arrayDeObjetos) => {
  const todasLasCanchas = [];

  arrayDeObjetos.forEach((objeto) => {
    const cancha = objeto.cancha;
    // Verificar si la cancha ya está en el array
    if (!todasLasCanchas.includes(cancha)) {
      todasLasCanchas.push(cancha);
    }
  });

  return todasLasCanchas;
};

const BotonExcel = ({ infoFlujo }) => {
  const [loading, setLoading] = useState(false);

  const handleDownload = () => {
    setLoading(true);

    const canchas = obtenerTodasLasCanchas(infoFlujo.armado);
    let jsonInfo = []; // Array para almacenar todos los objetos jsonInfo

    canchas.forEach((cancha) => {
      const filter = infoFlujo.armado.filter(
        (partido) => partido.cancha === cancha
      );

      const horariosOrdenados = ordenarPartidos(filter);

      const jsonPartido = horariosOrdenados.map((partido) => {
        return {
          "Equipo 1": partido.equipo1.Nombre,
          "Equipo 2": partido.equipo2.Nombre,
          Dia: partido.idTurno.Dia,
          Horario: partido.idTurno.horario,
          Cancha: partido.idTurno.Nombre,
        };
      });

      jsonInfo = jsonInfo.concat(jsonPartido); // Combinar los arrays jsonInfo
    });

    const libro = XLSX.utils.book_new();
    const hoja = XLSX.utils.json_to_sheet(jsonInfo);

    // Establecer el ancho de las columnas A y B
    const columnWidths = [
      { wch: 20 }, // Ancho de la columna A
      { wch: 20 }, // Ancho de la columna B
      { wch: 15 }, // Ancho de la columna C
      { wch: 7 }, // Ancho de la columna D
      { wch: 25 }, // Ancho de la columna E

      // Puedes agregar más objetos en este array para definir el ancho de más columnas si es necesario
    ];
    hoja["!cols"] = columnWidths;

    XLSX.utils.book_append_sheet(libro, hoja, "Resultado");

    setTimeout(() => {
      XLSX.writeFile(libro, "ResultadoFecha.xlsx");
      setLoading(false);
    }, 1000);
  };

  return (
    <>
      {!loading ? (
        <button className="btn btn-info m-1" onClick={handleDownload}>
          <RiFileExcel2Fill />
        </button>
      ) : (
        <button>
          <span> Generando...</span>
        </button>
      )}
    </>
  );
};

export default BotonExcel;
